// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import { useState } from 'react';
export const useCollapsed = externalCollapsed => {
  const [collapsed, setCollapsed] = useState(externalCollapsed ?? false);
  const [prevExternalCollapsed, setPrevExternalCollapsed] = useState(externalCollapsed);
  if (externalCollapsed !== prevExternalCollapsed) {
    setPrevExternalCollapsed(externalCollapsed);
    setCollapsed(externalCollapsed ?? false);
  }
  return [collapsed, setCollapsed];
};